const A15_MACHINE_ROOM_KEYS = [
  "a15-machine-room",
  "a15_machine_room",
  "A15_MACHINE_ROOM",
  "machineRoom",
];

const normalizeTestIds = (tests) =>
  (Array.isArray(tests) ? tests : [])
    .map((testId) => Number(testId))
    .filter((testId) => !Number.isNaN(testId));

export const getCurrentA15MachineRoom = () => {
  if (typeof window === "undefined") return "";

  const params = new URLSearchParams(window.location.search || "");
  const queryMachineRoom =
    params.get("machineRoom") || params.get("machine") || "";

  if (queryMachineRoom) {
    const normalizedMachineRoom = String(queryMachineRoom).trim();
    window.localStorage.setItem("a15-machine-room", normalizedMachineRoom);
    return normalizedMachineRoom;
  }

  for (const key of A15_MACHINE_ROOM_KEYS) {
    const value = window.localStorage.getItem(key);
    if (value) return String(value).trim();
  }

  return "";
};

export const getChemistryPackages = (chemistry = {}) => {
  const { packages = [] } = chemistry;

  if (packages && typeof packages === "object") {
    if (Array.isArray(packages)) return normalizeTestIds(packages);
    return normalizeTestIds(Object.keys(packages));
  }

  return packages ? normalizeTestIds([packages]) : [];
};

export const shouldHideChemistryFromCurrentMachine = (chemistry = {}) => {
  const lisSync = chemistry?.lisSync || {};
  const currentMachineRoom = getCurrentA15MachineRoom();

  if (!currentMachineRoom || !lisSync?.ownerMachine) return false;

  return (
    lisSync.isFullyClaimed === true && lisSync.ownerMachine !== currentMachineRoom
  );
};

export const getVisibleChemistryPackages = (chemistry = {}) => {
  const packages = getChemistryPackages(chemistry);
  const lisSync = chemistry?.lisSync || {};
  const currentMachineRoom = getCurrentA15MachineRoom();

  if (!lisSync?.ownerMachine || !currentMachineRoom) return packages;

  if (lisSync.ownerMachine === currentMachineRoom) return packages;

  if (lisSync.isFullyClaimed) return [];

  if (lisSync.isPartiallyClaimed) {
    const remainingTests = normalizeTestIds(lisSync.remainingTests);
    return remainingTests.length ? remainingTests : packages;
  }

  return packages;
};
